import { render, staticRenderFns } from "./PictureBookComment.vue?vue&type=template&id=7d7344c4&"
import script from "./PictureBookComment.vue?vue&type=script&lang=js&"
export * from "./PictureBookComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports